export class MinMaxDate {
    public MinDate: Date;
    public MaxDate: Date;
}
